import './App.css';
import Experience from './components/Experience';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App bg-first-pattern bg-cover bg-no-repeat bg-center">
      <div className=''>
        <Navbar />
        <Hero />
      </div>
      <div className='py-10'>
        <Skills />
      </div>
      <div className='py-10'>
        <Experience />
      </div>
      <div className='py-10'>
        <Projects />
      </div>
      <div className='pt-10 pb-20'>
        <Contact />
      </div>
      <Footer />
    </div>
  );
}

export default App;
